<!--
  - ===========================================================================
  - [StrongGate Limited] [http://www.stronggate.com]
  - Copyright (c) 2023. All rights Reserved.
  - Unauthorized access, use, dissemination, distribution, reproduction of this
  - file, or a portion of, in any form is prohibited and unlawful. If you receive
  - this file, and you are not an authorized company employee, or you believe you
  - have received this file in error, please notify the sender (or originator)
  - and promptly delete this file.
  -
  - Project:
  - File: dashboard.vue
  - Created by: ChanYing
  - Create Date: 2023-05-11 17:11
  - Version Number: 1.0
  - Version Description:
  -
  - =============================================================================
  -->

<template>
  <svg class="ztn-icon-md" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
          :stroke="strokeColor"
          stroke-width="var(--icon-stroke-md)"
          d="M2.49999 10.8333H3.33333V12.5V16.6667C3.33333 17.5858 4.08083 18.3333 4.99999 18.3333H15C15.9192 18.3333 16.6667 17.5858 16.6667 16.6667V12.5V10.8333H17.5C17.8367 10.8333 18.1417 10.63 18.27 10.3192C18.3992 10.0075 18.3275 9.64918 18.0892 9.41085L10.5892 1.91085C10.2633 1.58502 9.73666 1.58502 9.41083 1.91085L1.91083 9.41085C1.67249 9.64918 1.60083 10.0075 1.72999 10.3192C1.85916 10.63 2.16333 10.8333 2.49999 10.8333ZM10 3.67834L15 8.67834V12.5L15.0008 16.6667H5V12.5V10V8.67918L10 3.67834Z"
          :fill="strokeColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd"
          :stroke="strokeColor"
          stroke-width="var(--icon-stroke-md)"
          d="M9.99984 14.1667C11.8382 14.1667 13.3332 12.6717 13.3332 10.8333C13.3332 8.995 11.8382 7.5 9.99984 7.5C8.1615 7.5 6.6665 8.995 6.6665 10.8333C6.6665 12.6717 8.1615 14.1667 9.99984 14.1667ZM9.99967 9.16666C10.9188 9.16666 11.6663 9.91416 11.6663 10.8333C11.6663 11.7525 10.9188 12.5 9.99967 12.5C9.08051 12.5 8.33301 11.7525 8.33301 10.8333C8.33301 9.91416 9.08051 9.16666 9.99967 9.16666Z"
          :fill="strokeColor"/>
  </svg>
</template>

<script>
export default {
  name: "dashboard-svg",
  props: {
    strokeColor: {
      type: String,
      default: "var(--body-aux-1)"
    }
  },
}
</script>

